import { Watchlist } from '~/stores/use-watchlist/watchlist-types';

export const getUniqueTags = (watchlists: Watchlist[]) => {
  if (!watchlists.length) {
    return [];
  }
  const tags = watchlists
    .flatMap(list => list.entities)
    .map(entity => entity.tag);

  return [...new Set(tags)];
};
